<template>
  <div class="showTips">
    <van-popup
      :closeOnClickOverlay="false"
      v-model="showTips"
      :style="{ width: '70%' }"
    >
      <div class="content">当前企业近3个月的发票数据缺失，建议您重新上传。如继续提交可能会被拒绝。</div>
      <div class="footer">
        <div
          class="upload"
          @click="onUpload"
        >去上传</div>
        <div
          class="sure"
          @click="showTips = false"
        >确认</div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showTips: false,
    };
  },
  methods: {
    onUpload() {
      this.showTips = false;
      this.$emit('clickUpload');
    },
  },
};
</script>
<style lang="scss" scoped>
.showTips {
  .content {
    padding-top: 8px;
    color: #2f3133;
    padding: 26px 24px;
    font-size: 14px;
    line-height: 20px;
    word-wrap: break-word;
    text-align: left;
    text-indent: 2em;
  }
  .footer {
    display: flex;
    justify-content: center;
    padding-bottom: 20px;
    .upload {
      width: 100px;
      height: 40px;
      line-height: 40px;
      background: #ff6538;
      border-radius: 3px;
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      margin-right: 10px;
    }
    .sure {
      width: 100px;
      height: 40px;
      line-height: 40px;
      background: #ff6538;
      border-radius: 3px;
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
    }
  }
}
</style>
